export type GenderType = 'MALE' | 'FEMELLE' | 'HONGRE' | 'INCONNU'

export interface Gender {
  key: GenderType
  text: string
  short: string
}

const genders: Gender[] = [
  { key: 'MALE', text: 'Mâle', short: 'M' },
  { key: 'FEMELLE', text: 'Femelle', short: 'F' },
  { key: 'HONGRE', text: 'Hongre', short: 'H' },
  { key: 'INCONNU', text: 'Inconnu', short: 'I' },
]

const mapGenders: Map<string, string> = new Map()
genders.forEach((e) => {
  mapGenders.set(e.key, e.text)
})

const mapGendersShort: Map<string, string> = new Map()
genders.forEach((e) => {
  mapGendersShort.set(e.key, e.short)
})

export function getGenderLabel(key: string): string | undefined {
  return mapGenders.get(key)
}

export function getGenderShortLabel(key: string): string | undefined {
  return mapGendersShort.get(key)
}
export default genders
